import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'global_uvp_serp_searching',
    defaultMessage: 'Searching in thousands of sites',
  },
});



// WEBPACK FOOTER //
// ./app/Sources/loader/components/SourceLoader/messages.js